import React from 'react';

// const copyright= "© Sophia Knapp 2026";

import impressum from '../../assets/Impressum.png';



export const Impressum = () => {
    return (
                <div className="impressum" style={{textAlign: "center"}}>

                    <img
									src={impressum}
									alt="impressum"
								/>

             </div>


        // <div className="impressum" style={{textAlign: "center"}}>
        //     <br/>
        //     <br/>
        //     <br/>
        //     <span> IMPRESSUM
        //     </span>
        
        //     <br/>
        //     <span> Für den Inhalt dieser Website verantwortlich ist Sophia Knapp, Mortonstraße 25, 80937 München. Kontakt: info@sophiakundaliniyoga.de
        //     </span>
        //     <br/>
    

            
        //     <span>
        //     Die Inhalte dieser Seite unterliegen dem Copyright. Die Verwendung bzw. Vervielfältigung von Texten und Bildmaterial nur nach Absprache. 
        //     </span>
        //     <br/>
        //     <span> Copyright der Fotos, siehe Bildunterschriften. Header-Foto: © Sophia Knapp
        //     </span>
        //     <br/>
        //     <span> Webdesign und Programmierung: Sophia Knapp
        //     </span>
        //     <br/>
        //     <span>
        //     Keine Haftung für Inhalte externer Links.
        //     </span>
        //     {/* {copyright} */}
        //     <br/>
        //     <br/>
        //     <br/>
        //     </div>
    );
}